import { Link, useLocation } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export function useSearchReturn() {
  const { state } = useLocation();
  const from = state?.from;
  return typeof from === "string" && from.startsWith("/search") ? from : null;
}

export function BackToSearch({ className = "" }) {
  const from = useSearchReturn();
  if (!from) return null;
  return (
    <Link to={from} data-testid="back-to-search" className={`inline-flex items-center gap-1 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground ${className}`}>
      <ChevronLeft className="h-4 w-4" /> Back to search results
    </Link>
  );
}
